import { WorkItem } from '../work-item';
import { KiwiInstitutionDto } from 'src/app/shared/models/kiwi-institution/kiwi-institution-dto.model';
import { Inject, Injectable } from '@angular/core';
import { IUnitOfWorkFactory } from 'src/app/common/contracts/unit-of-work/unit-of-work-factory';
import { UnitOfWorkFactory } from 'src/app/common/unit-of-work/unit-of-work-factory';
import { KiwiInstitutionDB } from '../../common/repository/databases';

@Injectable({
  providedIn: 'root',
})
export class KiwiInstitutionWorkItem extends WorkItem<KiwiInstitutionDto> {
  constructor(@Inject(UnitOfWorkFactory) unitOfWorkFactory: IUnitOfWorkFactory) {
    super(unitOfWorkFactory);
  }

  get name(): string {
    return 'KiwiInstitutionWorkItem';
  }

  get database(): string {
    return KiwiInstitutionDB;
  }
}
